import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { PartService } from '../../../phf.service';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';

@Component({
  selector: 'optimization-results',
  templateUrl: './optimization-results.component.html',
  styleUrls: ['./optimization-results.component.scss']
})
export class OptimizationResultsComponent implements OnInit {

  optimizations: any;
  walkDistance: any;
  travelTime: any;
  selectableSettings: SelectableSettings;
  partId: any;
  editForm: FormGroup;
  sort: SortDescriptor[] = [{
    field: 'PercentSPM',
    dir: 'desc'
  }];

  @Input()
  show = false;
  @Input()
  set data(dataItem: any) {
    if (this.show && dataItem && dataItem.Id) {
      this.walkDistance = dataItem.WalkDistance;
      this.travelTime = dataItem.TravelTime;
      this.partId = dataItem.Id;
      this.partservice.read('/throughputcase/' + this.partId)
        .then(response => {
          this.optimizations = response;
          this.optimizations.forEach(element => {
            element.OverallTarget = `${this.formatNumber(element.OverallSPM)}/${this.formatNumber(element.TargetSPM)}`;

            element.WalkDistance = this.walkDistance;
            element.TravelTime = this.travelTime;
          });
          this.loadProducts();
        })
    }
  }
  @Output()
  apply: EventEmitter<any> = new EventEmitter();

  @Output()
  close: EventEmitter<any> = new EventEmitter();


  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly partservice: PartService, ) {
    this.setSelectableSettings();
  }

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      PercentSPM: [],
      SPMFlag: [],
      PercentSPMChange: [],
      NumberPeopleLoading: [],
      NumberPeopleLoadingChange: [],
      NumberPeopleSorting: [],
      NumberPeopleSortingChange: [],
      PeoplePerLift: [],
      PeoplePerLiftChange: [],
      AvailableTrucks: [],
      AvailableTrucksChange: [],
      WalkDistance: [],
      TravelTime: [],
    });
  }

  /**
   * 
   * @param value 
   */
  private formatNumber(value: string, format = 2): string {
    const _val: number = parseFloat(value);
    return isNaN(_val) ? '0' : _val.toFixed(format);
  }

  public sortChange(sort: SortDescriptor[]): void {
    if (sort[0].dir === undefined) {
      this.sort[0].dir = 'asc'
    } else {
      this.sort = sort;
    }

    this.loadProducts();
  }

  private loadProducts(): void {
    if (this.optimizations) {
      this.optimizations = orderBy(this.optimizations, this.sort);
    }
  }

  closeForm() {
    this.close.emit();
    this.show = false;
  }

  /**
   * Handles the action when apply button is clicked
   */
  onApply() {
    this.apply.emit(this.editForm.value);
    this.show = false;
  }

  /**
   * Settings for grid row selecting 
   */
  public setSelectableSettings(): void {
    this.selectableSettings = {
      mode: 'single',
    };
  }

  /**
   * When a row is selected set current editForm to the selected row data
   */
  public handleRowSelection(e: any) {
    if (e.selectedRows.length > 0) {
      const dataItem = e.selectedRows[0].dataItem;
      this.editForm.reset(dataItem);
    }
    else {
      this.editForm.reset([]);
    }
  }

  getColorClass = (flag: string): string => {
    return flag === 'G' ? 'cgp-success' :
      flag === 'Y' ? 'secondary-yellow' : 'cgp-red';
  }

  getColorClassByDiff = (diff: number): any => {
    return diff === 0 ? 'cgp-black' :
      diff < 0 ? 'cgp-success' : 'cgp-red';
  }

  isOptimizationSelected(): boolean {
    return this.editForm.value.PercentSPM !== null;
  }


}
